import { defineStore } from "pinia";
import type { SearchKeywordRes,SearchKeywordReq,SearchByCityRes,SearchByCityReq,HotelDetail,BookingHotelRes,BookingHotelReq,listPayments,createPaymentRequest,createPaymentResponse,DetaiReportlHotel,ReportHotel } from "~/istypes";
import { useUserStore} from "~/stores/user";

export const useHotelStore = defineStore('hotel', () => {
    const config = useRuntimeConfig();
    const userStore = useUserStore();

    const saveToLocalStorage = (key: string, data: any) => {
        localStorage.setItem(key, JSON.stringify(data));
    };

    const searchKeyword = async (data: SearchKeywordReq) => {
        try{
            const headers: Record<string, string> = {};

            headers["Device-Id"] = userStore.deviceId();
            
            if (userStore.token) {
                headers.Authorization = `Bearer ${userStore.token}`;
            }
            const res = await $fetch<SearchKeywordRes>(`${config.public.ApiBase}/hotels/search_keyword`,{
                method: "POST",
                body: data,
                headers
            });
            
            return res;

        }catch(error){
            return error;
        }
    }


    const searchByCity = async (data: SearchByCityReq) => {
        try{
            const headers: Record<string, string> = {};

            headers["Device-Id"] = userStore.deviceId();
            
            if (userStore.token) {
                headers.Authorization = `Bearer ${userStore.token}`;
            }
            const res = await $fetch<SearchByCityRes>(`${config.public.ApiBase}/hotels/search_city`,{
                method: "POST",
                body: data,
                headers
            });
            
            return res;

        }catch(error){
            return error;
        }
    }

    const detailHotel = async(data:SearchByCityReq ) => {
        try{
            const headers: Record<string, string> = {};

            headers["Device-Id"] = userStore.deviceId();
            
            if (userStore.token) {
                headers.Authorization = `Bearer ${userStore.token}`;
            }
            const res = await $fetch<HotelDetail>(`${config.public.ApiBase}/hotels/detail`,{
                method: "POST",
                body: data,
                headers
            });
            
            return res;

        }catch(error){
            return error;
        }
    }

    const bookingHotel = async (data: BookingHotelReq) => {
        if(userStore.token){
            try{
                const res = await $fetch<BookingHotelRes>(`${config.public.ApiBase}/hotels/booking`,{
                    method: "POST",
                    body: data,
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });
                
                return res;

            }catch(error){
                return error;
            }
        }
    }

    const getListPayments = async (id: number | string) => {
        if(userStore.token){
            try {
                const res = await $fetch<listPayments>(`${config.public.ApiBase}/hotels/payments`, {
                    method: "POST",
                    body: { transaction_id: id },
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const createPayment = async (data: createPaymentRequest) => {
        if(userStore.token){
            try {
                const res = await $fetch<createPaymentResponse>(`${config.public.ApiBase}/payments/create`, {
                    method: "POST",
                    body: data,
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getListReport = async (start_date?: Date | null, end_date?: Date | null) => {
        if (userStore.token) {
            try {
                const res = await $fetch<ReportHotel>(`${config.public.ApiBase}/hotels/reports`, {
                    method: "POST",
                    body: {
                        start_date: start_date,
                        end_date: end_date,
                    },
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getReportDetail = async (id: number | string) => {
        if (userStore.token) {
            try {
                const res = await $fetch<DetaiReportlHotel>(`${config.public.ApiBase}/hotels/reports/detail`, {
                    method: "POST",
                    body: { transaction_id: id },
                    headers: {
                        "Device-Id": userStore.deviceId(),
                        Authorization: `Bearer ${userStore.token}`
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const cancelBooking = async(id: any) => {
        if (userStore.token) {
            try {
                const res = await $fetch<any>(`${config.public.ApiBase}/hotels/cancel_booking`, {
                    method: "POST",
                    body:{
                        transaction_id:id
                    },
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    return { searchKeyword, searchByCity,detailHotel,bookingHotel,getListPayments,createPayment,getListReport,getReportDetail,cancelBooking};
});